import { render, staticRenderFns } from "./post-sticky.vue?vue&type=template&id=04de48e4&scoped=true&"
import script from "./post-sticky.vue?vue&type=script&lang=js&"
export * from "./post-sticky.vue?vue&type=script&lang=js&"
import style0 from "./post-sticky.vue?vue&type=style&index=0&id=04de48e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de48e4",
  null
  
)

export default component.exports